"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openStylesheetSelectModal = exports.openDateFormatHelpPanel = exports.openCustomMonthFormatCreatorModal = exports.openCustomDateTimeFormatCreatorModal = exports.openDeleteBlogModal = exports.openNewBlogModal = exports.openAmpPreviewModal = exports.ModalActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var ModalActionTypes = (0, _namespacedKeyMirror.default)({
  CLOSE_MODAL: null,
  OPEN_AMP_PREVIEW_MODAL: null,
  OPEN_NEW_BLOG_MODAL: null,
  OPEN_DELETE_BLOG_MODAL: null,
  OPEN_CUSTOM_DATE_TIME_FORMAT_CREATOR_MODAL: null,
  OPEN_CUSTOM_MONTH_FORMAT_CREATOR_MODAL: null,
  OPEN_DATE_FORMAT_HELP_PANEL: null,
  OPEN_STYLESHEET_SELECT_MODAL: null
}, 'blog');
exports.ModalActionTypes = ModalActionTypes;
var openAmpPreviewModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_AMP_PREVIEW_MODAL);
exports.openAmpPreviewModal = openAmpPreviewModal;
var openNewBlogModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_NEW_BLOG_MODAL);
exports.openNewBlogModal = openNewBlogModal;
var openDeleteBlogModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_DELETE_BLOG_MODAL);
exports.openDeleteBlogModal = openDeleteBlogModal;
var openCustomDateTimeFormatCreatorModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_CUSTOM_DATE_TIME_FORMAT_CREATOR_MODAL);
exports.openCustomDateTimeFormatCreatorModal = openCustomDateTimeFormatCreatorModal;
var openCustomMonthFormatCreatorModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_CUSTOM_MONTH_FORMAT_CREATOR_MODAL);
exports.openCustomMonthFormatCreatorModal = openCustomMonthFormatCreatorModal;
var openDateFormatHelpPanel = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_DATE_FORMAT_HELP_PANEL);
exports.openDateFormatHelpPanel = openDateFormatHelpPanel;
var openStylesheetSelectModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_STYLESHEET_SELECT_MODAL);
exports.openStylesheetSelectModal = openStylesheetSelectModal;
var closeModal = (0, _fluxActions.createAction)(ModalActionTypes.CLOSE_MODAL);
exports.closeModal = closeModal;